<template>
  <v-layout wrap text-center px-md-12>
     <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-flex xs12 pt-10 style="font-size: 30px; font-family: robotobold">
      Featured Products
    </v-flex>
    <v-flex sm6 md4 v-for="(item, i) in products" :key="i">
      <v-card flat>
        <v-layout wrap justify-center text-center px-10 py-6>
          <v-flex xs12 pb-2>
            <v-img
              max-height="500"
              :src="mediaURL + item.photos[0]"
            >
             <template v-slot:placeholder> <ImageLoader /> </template>
            </v-img>
          </v-flex>
          <v-flex style="font-family: robotobold" xs12 py-2>  {{ item.productName }} </v-flex>
          <!-- <v-flex xs12>
            <v-layout wrap justify-center>
              <v-flex xs1>
                <v-rating
                  :value="1"
                  color="amber"
                  half-increments
                  length="1"
                  readonly
                  size="14"
                ></v-rating>
              </v-flex>
              <v-flex xs1> 4.5 </v-flex>
              <v-flex xs1> 43 </v-flex>
            </v-layout>
          </v-flex> -->
          <v-flex xs12>
            <span style="font-weight: bold"> Rs. {{ item.offerPrice.toFixed(2)}}</span>
            <span v-if="item.price!=item.offerPrice" style="color: gray"> <del>Rs. {{ item.price }}</del></span>
          </v-flex>
          <v-flex xs12 pt-3>
            <v-btn @click="goTo(item._id)" color="#080B0A" tile width="100%">
              <span style="color: white; font-family: robotoregular">
                view details</span
              >
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex xs12 text-center py-2 pb-lg-0>
      <router-link
        style="text-decoration: none; color: black"
        :to="'/products'"
      >
        <v-btn color="#080B0A" outlined tile width="295px">
          <span style="color: #000000; font-family: robotobold">
            VIEW ALL PRODUCTS</span
          >
        </v-btn>
      </router-link>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      items: ["f2", "f1", "f3", "f2", "f1", "f3"],
      products:[],
      appLoading:false,
    };
  },
   mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/featured/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
           var temp = [];
            temp = response.data.data;
            if (temp.length > 6) {
              this.products = temp.slice(0, 6);
            } else {
              this.products = response.data.data;
            }
          // this.products = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    goTo(val) {
      this.$router.push({
        path: "/productdetail",
        query: {
          searchkey: val,
        },
      });
      console.log("val is=", val);
    },
  },
};
</script>